import { all } from "redux-saga/effects";

import AlertSaga from "./Alerts/saga";
import AuthSagas from "./Auth/saga";
import itemsSaga from "./Items/saga";
import rolesSaga from "./Roles/saga";
import userSagas from "./Users/saga";
import CareHomeGroupsSaga from "./CareHomeGroups/saga";
import HomesSaga from "./Homes/saga";
import EnquiriesSaga from "./Enquiries/saga";
import CareHearthSaga from "./CareHearth/saga";
import CareHearthBuyersSaga from "./CareHearthBuyers/saga";
import CareHearthInsightsSaga from "./CareHearthInsights/saga";
import NewsSaga from "./News/saga";
import FaqsSaga from "./Faqs/saga";
import SlickCareProfilesSaga from "./SlickCareProfiles/saga";
import HomeGroupsAdminSaga from "./HomeGroupsAdmin/saga";
import HomeGroupsStaffSaga from "./HomeGroupsStaff/saga";
import ReviewsSaga from "./Reviews/saga";
import PagesSaga from "./Pages/saga";
import BlogsSaga from "./Blogs/saga";
import ResidenceSaga from "./Residence/saga";
import LocationBlogsSaga from "./LocationBlogs/saga";
import TOCSaga from "./TypesOfCare/saga";
import WebsiteSaga from "./Website/saga";
import RoomSaga from "./Rooms/saga";
import SettingsSaga from "./EmailSettings/saga";
import ReviewsReplySaga from "./ReviewReply/saga";
import PackageSaga from "./Package/saga";
import EmailSaga from "./Email/saga";
import BundlesSaga from "./Bundles/saga";
import NotificationSaga from "./Notification/saga";

export default function* rootSaga() {
  yield all([
    userSagas(),
    AuthSagas(),
    rolesSaga(),
    itemsSaga(),
    AlertSaga(),
    CareHomeGroupsSaga(),
    HomesSaga(),
    EnquiriesSaga(),
    CareHearthSaga(),
    CareHearthBuyersSaga(),
    CareHearthInsightsSaga(),
    NewsSaga(),
    FaqsSaga(),
    SlickCareProfilesSaga(),
    HomeGroupsAdminSaga(),
    HomeGroupsStaffSaga(),
    ReviewsSaga(),
    PagesSaga(),
    BlogsSaga(),
    ResidenceSaga(),
    LocationBlogsSaga(),
    TOCSaga(),
    WebsiteSaga(),
    RoomSaga(),
    SettingsSaga(),
    ReviewsReplySaga(),
    PackageSaga(),
    EmailSaga(),
    BundlesSaga(),
    NotificationSaga(),
  ]);
}
